<div class="relative flex items-center">
  @if (currency()) {
    <ng-container *ngTemplateOutlet="selectedCurrencySymbol" />
  }

  <input
    type="text"
    inputmode="decimal"
    [class]="{
      '!pl-8': currency(),
      'pointer-events-none': disabled || readonly(),
      '!text-slate-400': disabled || readonly(),
    }"
    [ngModel]="value"
    (ngModelChange)="onInputChange($event)"
    (input)="onInputChange($event)"
    [placeholder]="placeholder()"
    [attr.pattern]="pattern()"
    (blur)="handleBlur()"
    (focus)="$event.target.select()"
    [disabled]="disabled"
    [readonly]="readonly()"
  />
</div>

<ng-template #selectedCurrencySymbol>
  <div
    class="absolute left-1 top-1/2 -translate-y-1/2 font-medium text-french-blue-600"
  >
    <!-- currency icon -->
    <div
      [class]="disabled || readonly() ? 'pointer text-slate-400' : ''"
      class="grid h-6 w-6 place-items-center"
    >
      {{ isPercentage() ? "%" : currencyService.getCurrencySymbol(currency()) }}
    </div>
  </div>
</ng-template>
